module.exports = __webpack_public_path__ + "static/media/order-change.4498696e.svg";